import React from 'react';

import * as ST from './styled';

const cityes = [
    {
        city: 'Санкт-Петербург,',
        link: 'https://interzet.dom.ru',
    },
    {
        city: 'Екатеринбург,',
        link: 'https://ekat.dom.ru',
    },
    {
        city: 'Пермь',
        link: 'https://perm.dom.ru',
    },
];
interface ICity {
    togglePopup: () => void,
}

const City = ({ togglePopup }: ICity) => {
    return (
        <ST.Wrapper>
            <ST.Text>
                {cityes.map((item, index) => (
                    <ST.Link href={item.link} key={index}>{item.city}</ST.Link>
                ))}
                или выберите
                <ST.Link href='#' onClick={togglePopup}> из списка</ST.Link>
            </ST.Text>
        </ST.Wrapper>
    );
};

export default City;
